import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { useGame } from "@/context/GameContext";
import { t } from "@/lib/translations";
import badgeGold from "@/assets/badges/badge_star_gold.png";
import badgeComplete from "@/assets/badges/badge_complete.png";

export default function StarReward({ show, onAgain, onClose, themeColor = "#38BDF8", starsEarned = 1, isLayerComplete = false }) {
  const { language } = useGame();

  const confettiColors = ["#F87171", "#FDE047", "#4ADE80", "#38BDF8", "#C084FC"];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-40 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4"
          data-testid="star-reward"
        >
          {/* Confetti */}
          {Array.from({ length: 30 }).map((_, i) => (
            <motion.span
              key={`confetti-${i}`}
              className="confetti-dot"
              style={{
                background: confettiColors[i % confettiColors.length],
                left: "50%",
                top: "50%",
              }}
              initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
              animate={{
                x: (Math.random() - 0.5) * 600,
                y: (Math.random() - 0.5) * 600,
                opacity: 0,
                scale: 0.4,
                rotate: Math.random() * 360,
              }}
              transition={{ duration: 1.4, ease: "easeOut" }}
            />
          ))}

          <motion.div
            initial={{ scale: 0.3, rotate: -15 }}
            animate={{ scale: 1, rotate: 0 }}
            exit={{ scale: 0.3 }}
            transition={{ type: "spring", damping: 12, stiffness: 200 }}
            className="bg-white rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl"
          >
            <motion.img
              src={(starsEarned === 3 || isLayerComplete) ? badgeComplete : badgeGold}
              initial={{ scale: 0, rotate: -15 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: "spring", damping: 10, stiffness: 200 }}
              className="w-32 h-32 mx-auto object-contain"
              alt="Achievement Badge"
            />
            <h2 className="font-display text-4xl font-bold mt-3" style={{ color: themeColor }}>
              {t("great_job", language)}
            </h2>
            <p className="text-slate-600 mt-1 text-lg font-bold">{t("yay", language)}</p>
            <div className="grid grid-cols-2 gap-3 mt-6">
              <button
                onClick={onClose}
                className="toy-btn py-3 rounded-2xl bg-slate-200 hover:bg-slate-300 font-display text-lg font-bold text-slate-700 shadow-[0_4px_0_#94a3b8]"
                data-testid="reward-close"
              >
                {t("back", language)}
              </button>
              <button
                onClick={onAgain}
                className="toy-btn py-3 rounded-2xl text-white font-display text-lg font-bold shadow-[0_4px_0_rgba(0,0,0,0.25)]"
                style={{ background: themeColor }}
                data-testid="reward-again"
              >
                {t("again", language)}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
